import React from "react";
import { Button, Stack } from "@mui/material";

export const EditActionButtons = ({
  handleCancel,
  handleDelete,
  isDeleteButtonPresent = false,
  previousData,
  saveChanges,
  isDirty,
  reset,
}) => {
  return (
    <Stack
      mt={2}
      mb={2}
      width={"100%"}
      direction={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={1}
    >
      {/* <Button variant="outlined" onClick={handleCancel}>
        Cancel
      </Button> */}
      {isDeleteButtonPresent && (
        <Button
          variant="outlined"
          color="warning"
          onClick={handleDelete}
          sx={{ padding: "10px 30px" }}
        >
          Delete
        </Button>
      )}
      {/* <Button
        variant="contained"
        color="warning"
        onClick={() => reset(previousData)}
        disabled={!isDirty}
      >
        Discard Changes
      </Button> */}
      <Button
        variant="contained"
        onClick={saveChanges}
        disabled={!isDirty}
        sx={{ padding: "10px 30px" }}
      >
        Save Changes
      </Button>
    </Stack>
  );
};
